import moment from "moment";

export const sortDESC = function (a: any, b: any) {
  if (a.id < b.id) {
    return 1;
  }
  if (a.id > b.id) {
    return -1;
  }
  return 0;
};

export const sortASCStatus = function (a: any, b: any) {
  if (a.status_documento.id > b.status_documento.id) {
    return 1;
  }
  if (a.status_documento.id < b.status_documento.id) {
    return -1;
  }
  return 0;
};

export const sortASC = function (a: any, b: any) {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
};

export const sortYear = function (a: any, b: any) {
  if (a.ano_competencia < b.ano_competencia) {
    return 1;
  }
  if (a.ano_competencia > b.ano_competencia) {
    return -1;
  }
  return 0;
};

export const sortMesCompetencia = function (a: any, b: any) {
  if (a.mes_competencia < b.mes_competencia) {
    return 1;
  }
  if (a.mes_competencia > b.mes_competencia) {
    return -1;
  }
  return 0;
};

export const sortCreated = function (a: any, b: any) {
  if (moment(a.created_at).format() < moment(b.created_at).format()) {
    return 1;
  }
  if (moment(a.created_at).format() > moment(b.created_at).format()) {
    return -1;
  }
  return 0;
};
